<template>
  <Dialog v-model="dialog" :width="440" title="文法解説登録" closable>
    <template v-slot:activator="{ on }">
      <v-btn class="mx-3" small v-on="on" color="primary"
        >自習の文法解説から選択</v-btn
      >
    </template>
    <template v-slot:content>
      <v-row class="ma-0">
        <v-col cols="3" class="pa-0 d-flex">
          <strong class="mt-3">文法名</strong>
        </v-col>
        <v-col class="pa-0">
          <v-select
            :items="grammarListInSelfStudy"
            item-text="name"
            item-value="Id"
            dense
            v-model="grammarSelect"
            outlined
            class="mt-2"
          />
        </v-col>
      </v-row>
      <v-row class="ma-0 mb-2" justify="center">
        <div
          class="preview overflow-y-auto"
          style="min-width: 24.5rem; max-width: 24.5rem"
        >
          <v-row class="ma-0">
            <v-col
              v-for="(field, index) in fieldsGrammar"
              :key="index"
              v-bind="field"
              class="py-1"
              :cols="field.cols"
              :class="{ 'is--active': field === activeFieldGrammar }"
            >
              <component
                :is="field.fieldType"
                :currentField="field"
                class="form__field not-border"
              ></component>
            </v-col>
          </v-row>
        </div>
      </v-row>
      <VocabularyList no-action style="min-height: 80px" />
    </template>
    <template v-slot:actions>
      <v-btn
        class="primary mr-5"
        :loading="loading"
        small
        :disabled="loading"
        @click="handleSave"
        >決定</v-btn
      >
      <v-btn small color @click="dialog = false">{{ $t("CANCEL") }}</v-btn>
      <v-spacer />
    </template>
  </Dialog>
</template>

<script>
import { FormBuilder } from "@/components/form_elements_gramma/formbuilder";
import Elements from "@/components/form_elements_gramma/Elements";
import Dialog from "@/components/Dialog/Dialog";

import VocabularyList from "./vocabulary/VocabularyList";
FormBuilder.$options.components["Elements"] = Elements;
FormBuilder.$options.components["Dialog"] = Dialog;

FormBuilder.$options.components["VocabularyList"] = VocabularyList;
import { getListSelfGrammar, createGrammar } from "@/api/Grammar.api";
export default {
  store: [
    "fieldsGrammar",
    "activeFieldGrammar",
    "activeTabForFieldsGrammar",
    "mainGrammar",
    "tab",
    "drawer",
    "vocabularyGrammar",
  ],
  components: FormBuilder.$options.components,
  data() {
    return {
      dialog: false,
      loading: false,
      grammarListInSelfStudy: [],
      grammarSelect: "",
    };
  },
  watch: {
    dialog: async function (val) {
      if (!val) {
        this.fieldsGrammar = [];
        this.activeFieldGrammar = {};
        this.activeTabForFieldsGrammar = "elements";
        this.mainGrammar = "Edit";
        this.grammarSelect = "";
        this.vocabularyGrammar = [];
      } else {
        await this.handleFetchListSelfGrammar();
      }
    },
    grammarSelect: function (val) {
      console.log("val: ", val);
      let grammarSelect = this.grammarListInSelfStudy.find((e) => e.Id == val);

      if (grammarSelect) {
        console.log("grammarSelect: ", grammarSelect.vocabulary);
        this.vocabularyGrammar = grammarSelect.vocabulary;
        grammarSelect.data.forEach((item) => {
          if (item.type == "image" && item.file) {
            item.file.fileUrl = `${item.image_url}`;
            delete item.file.file;
            delete item.file.formData;
          }
          if (item.key == "ExampleSentence" && item.file) {
            item.file.fileUrl = `${item.audio_url}`;
            delete item.file.file;
            delete item.file.formData;
          }
        });
        this.fieldsGrammar = grammarSelect.data;
      }
      this.mainGrammar = "Preview";
    },
  },
  methods: {
    async handleFetchListSelfGrammar() {
      let params = {
        sub_key: this.$route.params.section,
      };
      await getListSelfGrammar(params)
        .then(({ result }) => {
          result.forEach((item) => {
            item.name = "";
            item.data.forEach((data) => {
              if (data.key == "Title") {
                item.name += data.value.ja;
              }
            });
          });
          console.log("result: ", result);
          this.grammarListInSelfStudy = result;
        })
        .catch((error) => {
          this.$toast.error(error);
        });
    },
    async handleSave() {
      if (this.grammarSelect) {
        this.loading = true;
        let params = {
          section: this.$route.params.section,
          grammar_id: this.grammarSelect,
          data: [],
        };
        await createGrammar(params)
          .then(() => {
            this.$emit("resetList");
            this.dialog = false;
            this.loading = false;
          })
          .catch((error) => {
            this.$toast.error(error);
            this.loading = false;
          });
      }
    },
    handleCancel() {
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.preview {
  border: 1px solid #cccccc;
  min-height: 25.5rem;
}
</style>